import { AxiosResponse } from 'axios';
import $api from '@/http/index';
import { ITourPublished } from '@models/tours/ITourPublished';
import { IUpdateTourProgress } from '@models/tours/IUpdateTourProgress';

export interface ITourEventPayload {
    tourId: string;
    sessionId: string;
    eventType: string;
    stepIndex?: number;
    stepId?: string;
    branchLabel?: string;
    branchTargetIndex?: number;
    actionType?: string;
    nextTourCode?: string;
    durationMs?: number;
    pageUrl?: string;
    metadata?: string;
}

export class ToursService {
    static async fetchPublished(): Promise<AxiosResponse<ITourPublished[], any>> {
        return $api.get<ITourPublished[]>(`/tours/published`);
    }

    static async updateProgress(data: IUpdateTourProgress): Promise<AxiosResponse<void>> {
        return $api.put(`/tours/progress`, data);
    }

    static async resetProgress(tourId: string): Promise<AxiosResponse<void>> {
        return $api.post(`/tours/${tourId}/reset`);
    }

    static async trackEvent(event: ITourEventPayload): Promise<void> {
        try {
            await $api.post(`/tours/events`, event);
        } catch {
            // Fire-and-forget: не блокируем UX при ошибке аналитики
        }
    }

    static async trackEvents(events: ITourEventPayload[]): Promise<void> {
        if (events.length === 0) return;
        try {
            await $api.post(`/tours/events/batch`, events);
        } catch {
            // Fire-and-forget
        }
    }
}
